<template>
  <v-select
      v-model="selected"
      :items="items"
      :variant="useGlobalSetting().globalTextVariant"
      :rules="rules"
      item-title="displayName"
      item-value="name"
      label="Gruppe"
  >
    <template v-slot:prepend-item>
      <v-list-item-title class="text-center font-weight-bold">
        Auswahl der Gruppe
      </v-list-item-title>
      <v-divider></v-divider>
    </template>

    <template v-slot:item="{ props, item }">
      <v-list-item
          v-if="item.raw.permission <= maxPermission && item.raw.permission >= minPermission"
          :subtitle="item.raw.name"
          :title="item.raw.displayName"
          v-bind="props">
        <template v-slot:prepend>
          <v-avatar :class="item.raw.color">
            <v-icon>{{ item.raw.icon }}</v-icon>
          </v-avatar>
        </template>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      <v-avatar :class="`${item.raw.color} mr-2`" size="25">
        <v-icon class="pa-0 mr-0" size="18">{{ item.raw.icon }}</v-icon>
      </v-avatar>
      <span>{{ item.raw.displayName }}</span>
    </template>
  </v-select>
</template>

<script lang="ts" setup>
import {Groups} from "@/types/Order";
import {computed} from "vue";
import {useGlobalSetting} from "@/lib/utils";

const selected = defineModel()

const props = defineProps({
  variant: {
    type: String,
    default: "outlined"
  },
  maxPermission: {
    type: Number,
    default: 1
  },
  minPermission: {
    type: Number,
    default: 0
  },
  required: {
    type: Boolean,
    default: false
  },
  rules: {
    type: Array,
    default: () => []
  }
})

const rules = computed(() => props.rules)

const items = computed(() => Object.values(Groups));
</script>
